import { render } from "./NavigationButtons.vue?vue&type=template&id=3c55b0fc&scoped=true"
import script from "./NavigationButtons.vue?vue&type=script&lang=js"
export * from "./NavigationButtons.vue?vue&type=script&lang=js"

import "./NavigationButtons.vue?vue&type=style&index=0&id=3c55b0fc&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c55b0fc"]])

export default __exports__